import { TESTID } from '_shared/config/testID'
import LoadingComponent from 'components/atoms/Loading'
import SplashBackground from 'components/organisms/SplashBackground'
import SplashLogoBanner from 'components/organisms/SplashLogoBanner'
import React, { useImperativeHandle, useRef, useState } from 'react'
import { StyleSheet, View } from 'react-native'
import * as Animatable from 'react-native-animatable'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { ThemedShared, ThemedValues } from 'styles/themed'
import HelperString from 'utils/helper-string'

const SplashView = React.forwardRef((props, ref) => {

	const animateRef = useRef()
	const insets = useSafeAreaInsets();

	const [ percentage, setPercentage ] = useState( 0 )

	const fadeOut = ( onComplete ) => {
		if( animateRef.current !== undefined && animateRef.current !== null ){
			animateRef.current?.stopAnimation();
			animateRef.current?.fadeOut( 250 ).then( onComplete );
		}
	}

	useImperativeHandle(ref, () => {
		return (
			{
				setPercentage( value ) {
					setPercentage( value )
				},
				fadeOut( onComplete ) {
					fadeOut( onComplete )
				}
			}
		);
	});

	return (
		<Animatable.View
			key={ HelperString.hash( "splash_animation") }
			ref={ animateRef }
			style={ styles.container }>

			<View
				key={ HelperString.hash( "splash_loading_container" ) }
				style={ styles.container }
				testID={ TESTID.INTERFACE.SPLASH_SCREEN }>

				<View
					style={ styles.splashContainer }>

					<SplashBackground />
				</View>

				<SplashLogoBanner
					lowConnection={ props.slowConnection }
				/>

				<View 
					style={[ styles.loader, { paddingTop: insets.top } ]}>

					<LoadingComponent
						size={ 'm' }
						progress={ percentage / 100  }
					/>
				</View>
			</View>
		</Animatable.View>
	)
})

const styles = StyleSheet.create( {
	container: {
		position: 'absolute',
		left: 0,
		top: 0,
		width: '100%',
		height: '100%',
		flex: 1,
		zIndex: 1000,
	},

	splashContainer: {
		flex: 1,
	},

	loader: {
		position: 'absolute',
		width: '100%',
		top: 0,
		left: 0,
		paddingRight: ThemedShared.paddingSmall.padding,
		alignItems: 'flex-end',
	},
	loaderOverlay: {
		position: 'absolute',
		left: 0,
		top: 0,
		bottom: 0,
		right: 0,
		borderRadius: ThemedValues.borderRadius
	}
});

export default SplashView
